import React from 'react';
import { ITaskProps } from '../model/types/task-props.interface';
import styles from './index.module.css';
import { TaskDescription } from './TaskDescription';
import { IconsWrapper } from './IconsWrapper';
import { TagsList } from './TagsList';
import { TaskTitle } from './TaskTitle';
import { Icon, RadioBtn, TaskDate } from 'shared/ui';
import classnames from 'classnames';
import { TaskExecutor } from './TaskExecutor';
import { TaskCreatedData } from './TaskCreatedData';
import { useTaskData } from '../hooks/useTaskData';

//todo рефактор. здесь слишком много логики для entity-компонента

export function ListTask({ uid, isDone }: ITaskProps) {
    const {
        createdAtFormatted,
        authorName,
        executorAvatar,
        executorName,
        taskTags,
        toggleHover,
        taskData,
        taskIsDone,
        dateStartFormatted,
        dateEndFormatted,
        handleDoneTaskClick,
        handleTaskClick,
        isHovered,
        isOverdue,
        boardColor,
    } = useTaskData(uid, isDone);

    return (
        <div className={styles.TaskWrapper} onMouseEnter={toggleHover} onMouseLeave={toggleHover}>
            <div
                className={styles.BtnOnHoverRevealContainer}
                data-task-type={taskData?.type}
                data-task-is-observer={taskData?.context?.highest_role === 'observer'}
            >
                {taskData?.type === 'custom' && (
                    <RadioBtn
                        isChecked={taskIsDone}
                        onClickHandler={handleDoneTaskClick}
                        fill={isOverdue ? '#C1281B' : undefined}
                    />
                )}
            </div>
            <div
                className={classnames(
                    styles.BoardListItem,
                    isOverdue && !taskData.completed && styles.isOverdue
                )}
                onClick={handleTaskClick}
                style={{
                    borderRadius: '6px',
                    borderLeft: `4px solid ${boardColor}`,
                }}
            >
                <div className={styles.container}>
                    <div className={styles.info}>
                        <div className={styles.leftSide}>
                            <div className={styles.TaskTitleWrapper}>
                                <TaskTitle
                                    taskIsDone={taskIsDone}
                                    taskTitle={taskData?.title}
                                    isOverdue={isOverdue}
                                    isCompleted={taskData?.completed}
                                    classes={
                                        dateStartFormatted === null && dateEndFormatted === null
                                            ? styles.twoLines
                                            : styles.oneLine
                                    }
                                />

                                <TaskDate
                                    dateStart={dateStartFormatted}
                                    dateFinished={dateEndFormatted}
                                    isOverdue={isOverdue}
                                    canOverdue={isOverdue && !taskData?.completed}
                                />
                            </div>
                            {taskData?.type === 'custom' && (
                                <IconsWrapper
                                    taskId={taskData?.uid}
                                    entityUid={taskData?.context?.entity_uid}
                                    isHovered={isHovered}
                                    currentStatus={taskData?.context?.status}
                                />
                            )}
                        </div>
                        <div className={styles.rightSide}>
                            <TaskExecutor name={executorName} avatarSrc={executorAvatar} />
                            <TaskDescription description={taskData?.description} />
                            {taskTags.length > 0 && <TagsList tags={taskTags} />}
                        </div>
                        <div className={styles.doList}>
                            {taskData?.type === 'custom' && (
                                <TaskCreatedData
                                    createdAtDate={createdAtFormatted}
                                    authorName={authorName}
                                />
                            )}
                            {isHovered && taskData?.type === 'system' && (
                                <span className={styles.IconLink}>
                                    <Icon iconName="taskIconLink" />
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
